export class EarlyExitDetails {
  public exitReason: string;
  public contactMe: string;
  public name: string;
  public number: string;
}
